import { env } from '@/lib/config/env'

/**
 * Uploads are served from the API origin (`/uploads/...`), not under
 * `/api/v1`. Same-origin deployments can use the relative URL as-is; when
 * `VITE_API_BASE_URL` points at another origin, prefix that origin so avatars
 * and covers resolve in the web app and inside the Tauri shell.
 */
export function resolveMediaUrl(
  value: string | null | undefined,
): string | null {
  return resolveMediaUrlWithBase(value, env.apiBaseUrl)
}

/** Exposed for tests and non-env callers that already know the API base. */
export function resolveMediaUrlWithBase(
  value: string | null | undefined,
  apiBaseUrl: string,
): string | null {
  const raw = value?.trim()
  if (!raw) return null
  // Never pass a local filesystem URL into an <img>; the browser blocks it
  // from an HTTPS origin and it can leak a local path into the DOM.
  if (/^file:/i.test(raw)) return null
  if (/^(https?:|blob:|data:)/i.test(raw)) return raw
  const path = raw.startsWith('/') ? raw : `/${raw}`
  if (/^https?:\/\//i.test(apiBaseUrl)) {
    try {
      const origin = new URL(apiBaseUrl).origin
      return `${origin}${path}`
    } catch {
      return path
    }
  }
  return path
}
